export default __webpack_public_path__ + "08d660bfc5fb3c21d862cdc6aa3711f2.png";